import { BackgroundColors } from '@picsart/design-system/foundation/colors';

import { Spacings } from '@picsart/design-system/foundation/spacings';

// import { BreakPoints } from '@picsart/design-system/foundation/responsive';
import { createUseStyles } from 'react-jss';

const IFRAME_HEIGHT = 576;

const useStyles = createUseStyles(
  () => ({
    root: {
      backgroundColor: BackgroundColors.tint3,
      maxWidth: '100%',
      marginTop: Spacings.s48,
      marginBottom: Spacings.s48,

      // [mediaQuery(BreakPoints.Small)]: {
      // '@media screen and (max-width: 766px)': {
      //   '& > $iframe': {
      //     height: 400,
      //   },
      // },

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        '& > $iframe': {
          height: 180,
        },
      },
    },
    skeletonRoot: {
      extend: 'root',
      height: IFRAME_HEIGHT,
    },
    iframe: {
      display: 'block',
      width: '100%',
      height: IFRAME_HEIGHT,
    },
    placeholder: {
      position: 'relative',
    },
    image: {
      '& > img': {
        display: 'block',
        width: '100%',
        height: 576,

        // [mediaQuery(BreakPoints.Small)]: {
        // '@media screen and (max-width: 766px)': {
        //   height: 400,
        // },

        // [mediaQuery(766)]: {
        '@media screen and (max-width: 766px)': {
          height: 180,
        },
      },
    },
    button: {
      position: 'absolute',
      left: Spacings.s0,
      top: Spacings.s0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
    },
    icon: {
      display: 'inline-block',
      height: 120,
      width: 100,
      cursor: 'pointer',
    },
  }),
  { name: 'youtube-video' },
);

export default useStyles;
